import { useQuery } from '@tanstack/react-query';
import { api, LitSquadCraftIngredientsResult } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

/**
 * Loads the six crafting slots — which DFE items each slot accepts and
 * how many the user currently owns across all locations.
 */
export function useLitSquadCraftIngredients() {
  const { data, isLoading, error, refetch } = useQuery<LitSquadCraftIngredientsResult>({
    queryKey: queryKeys.litSquad.craftIngredients(),
    queryFn: () => api.getLitSquadCraftIngredients(),
  });

  return {
    slots: data?.slots ?? [],
    loading: isLoading,
    error: error instanceof Error ? error.message : error ? 'Failed to load ingredients' : null,
    refresh: () => {
      refetch();
    },
  };
}
